const domainFromHostname = () =>
  window.location.hostname.replace(/^[\w-]+\.([\w-]+)\.([\w-]+)$/, '.$1.$2');

export default domainFromHostname;
